import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";

export class ImportBatch extends HasProjectMixin(Model) {
  static get $name() {
    return "ImportBatch";
  }

  static get fields() {
    return [
      { name: "fileName", dataSource: "file_name" },
      { name: "fileUrl", dataSource: "file_url" },
      { name: "entityType", dataSource: "entity_type" },
      { name: "recordsImported", dataSource: "records_imported" },
      { name: "importDate", dataSource: "import_date", type: "date" },
      { name: "importedBy", dataSource: "imported_by" },
      { name: "isReverted", dataSource: "is_reverted" },
      { name: "revertedBy", dataSource: "reverted_by" },
      { name: "revertedByUserName"}
    ];
  }

  get revertedByUserName() {
    if (this.project) {
      return this.project.boardUsersStore.find((user) => user.id === this.importedBy)?.name;
    }
    return null;
  }
}
